import React, {useContext, useState} from 'react'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import Panel from '../cmp/Panel.js';

function FldMenuGrpEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabChoice=actions.tabChoice
    const tabClose=actions.tabClose
    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg
    const langs=context.data['sysConst']['langs']||[]
    const loaddata=context.loaddata
    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if (data==='') newData[name]=null
        else newData[name]=data
        setWndData(newData)
    }

    const generateTranslations = () => {
        if (!langs || langs.length === 0 || langs.every(l => Number(l.is_used) === 0)) {
            msg(localestr('Оберіть мову для перекладу в налаштуванням онлайн меню'), localestr('Помилка'), [{
                caption: 'OK',
                action: () => {}
            }]);
            return;
        }
    
        const selectedLangs = langs.filter(l => Number(l.is_used) === 1).map(i => i.code);
        let newData = {...wndData, changed: true};
        if (!wndData.id) {

            let items = [{
                type: 2,
                data: [{
                    id: 0,
                    name: wndData?.name ?? '',
                    description: wndData?.description || null,
                }],
                fields: ['name']
            }];
    
            loaddata(
                `action=translation&data=${JSON.stringify({
                    langs: selectedLangs,
                    items,
                    new: true
                })}`,
                undefined,
                (d) => processTranslationData(d, newData)
            );
        } else {
    
            loaddata(
                `action=translation&data=${JSON.stringify({
                    langs: selectedLangs,
                    entities: [{type: 2, ids: [wndData.id]}]
                })}`,
                undefined,
                (d) => processTranslationData(d, newData)
            );
        }
    };

    const processTranslationData = (responseData, newData) => {
        newData.translations = {
            en: {name: ''},
            de: { name: '' },
            it: { name: '' },
            hu: {name: ''}
        };

        if (responseData.data['2']) {
            for (const key in responseData.data['2']) {
                const product = responseData.data['2'][key];
                for (const lang in product) {
                    if (newData.translations[lang]) {
                        newData.translations[lang].name = product[lang]?.name || '';
                        newData.translations[lang].type = 2;
                    }
                }
            }
        }
        setWndData(newData, true);
    };
    const saveValue=()=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,50)
        const sorting=wndData.sorting || null
        const id=wndData.id
        const translations = wndData?.translations ?? {};

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'FldMenuGrp',data:{name,sorting, translations: {...translations}}}
                saveData(newData,tabClose)
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'FldMenuGrp',data:{id,name,sorting, translations: {...translations}}}
                //saveData(newData,tabClose)
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);if(tabChoice) tabChoice(d.data);tabClose()})
            }        
            else tabClose()
        }

    }

    const setTranslationValue = (name, code, data) => {
        let newData={...wndData,changed:true}
        // console.log(name, code, data);
        let translations=wndData.translations || {}
        if (!translations[code]) translations[code]={name:"", type: 2}
        if (data==='') translations[code][name]=null
        else translations[code][name]=data
        console.log(translations);
        newData['translations'] = translations
        setWndData(newData,true)
    }

    const [activeTab, setActiveTab] = useState(langs.find(l => l.code !== 'uk')?.code || '');
    let langs_cont=''
    if(langs.length>0) {
        langs_cont=<Panel caption={localestr('Переклади')} width={792} open={wndData.p_lang===undefined?false:wndData.p_lang} setOpen={d=>setWndData({...wndData,p_lang:d})}>
            <div style={{ display: 'flex', gap: '2px' }}>
                {langs.map(item => item.code !== 'uk' ? (
                    <button key={item.code} onClick={() => setActiveTab(item.code)} 
                        className={`tabbuton ${activeTab === item.code && "active"}`}
                        style={{maxWidth: "150px", padding: "0px" }}>{item.name}</button>
                    ) : null
                )}
            </div>
            {langs.map(item =>
                item.code !== 'uk' && item.code === activeTab ? (
                    <div key={item.id} style={{margin:'2px 0',display:'inherit'}}>
                    <div style={{margin:'0',display:'inherit',flexDirection:'column',width:'492px',maxWidth:'1300px',flexGrow:492}}>
                        <EditCtrl Capt={localestr('Назва')} Value={wndData?.translations?.[item.code]?.name || ""} typeVal={'text'} 
                        setVal={(d)=>{setTranslationValue('name',item.code,d)}} width1='92' width2='404'/>
                    </div>
                    </div>
                ) : null
            )}
            <div className='no-print' style={{margin:'0',minWidth:'337px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
                <div style={{width:'250px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} 
                onClick={()=>generateTranslations()}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>
                {localestr('Згенерувати автопереклад')}</div></div>
            </div>
        </Panel>
    }

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
    <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='46' width2='50' disabled={true}/>
    <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
    <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='183'/>
        </div>
        <EditCtrl Capt={localestr('Порядок сортування')} Value={wndData.sorting} typeVal={'number'} setVal={(d) => { setValue('sorting', d) }} width1='155' width2='32' />
        {langs_cont}

    <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default FldMenuGrpEdit